import querystring from "qs";
import { localStorageKeys } from "../../global/constants";

const { TOKEN } = localStorageKeys;

const token = localStorage.getItem(TOKEN);


export const TIMEOUT = 2000000;
export const BASE_URL = process.env.REACT_APP_API_URL;

console.log("----process.env", process.env);
export const PARAM_SERIALIZER = (params) =>
  querystring.stringify(params, { arrayFormat: "brackets" });
export const AUTH_TOKEN_VALUE = token
  ? `Bearer ${token}`
  : "";

